export default __webpack_public_path__ + "static/media/s3-004.dcacbe87.jpg";